import { useEffect, useState, useCallback } from 'react';
import { noop } from 'lodash-es';

import { Modal } from 'modules/v2/common/components';

import ModalContent from './ModalContent';

// TODO: needs to be moved on into common module components
const FilePickerModal = ({
  // DATA
  images,
  logos,
  type,
  isOpen,
  title,
  isConfirmLoading,
  isImagesLoading,
  isLogosLoading,

  // CALLBACKS
  onConfirm,
  onCancel,
  onDelete,
  onGalleryTabOpen = noop,
  onLogosTabOpen,
}) => {
  const [image, setImage] = useState(null);
  const [imageFormat, setImageFormat] = useState();
  const [group, setGroup] = useState('upload');

  const handleConfirm = useCallback(() => {
    if (image instanceof HTMLCanvasElement) {
      onConfirm(image.toDataURL(imageFormat, 0.7), group, imageFormat);
    } else if (typeof image === 'string') {
      onConfirm(image, group, imageFormat);
    }
  }, [image]);

  useEffect(() => {
    if (image !== null) {
      handleConfirm();
    }
  }, [image, handleConfirm]);

  const handleSelect = (img, format) => {
    setImage(img);
    setImageFormat(format);
  };

  return (
    <Modal
      isOpen={isOpen}
      confirmLoading={isConfirmLoading}
      maskClosable={false}
      title={title}
      width="630px"
      onCancel={onCancel}
      footer={null}
    >
      <ModalContent
        type={type}
        images={images}
        logos={logos}
        isImagesLoading={isImagesLoading}
        isLogosLoading={isLogosLoading}
        onChangeTab={setGroup}
        onSelect={handleSelect}
        onDelete={onDelete}
        onGalleryTabOpen={onGalleryTabOpen}
        onLogosTabOpen={onLogosTabOpen}
        onSuccess={handleConfirm}
      />
    </Modal>
  );
};

export default FilePickerModal;
